var React = require('react');

function Cart (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Layer_2","data-name":"Layer 2"},[React.createElement("path",{"d":"m24.9 31h-17.8a3 3 0 0 1 -3-3.15l.81-17.24a3 3 0 0 1 3-2.87h16.18a3 3 0 0 1 3 2.87l.81 17.24a3 3 0 0 1 -3 3.15zm-16.99-21.25a1 1 0 0 0 -1 1l-.81 17.2a1 1 0 0 0 1 1.05h17.8a1 1 0 0 0 1-1.05l-.81-17.24a1 1 0 0 0 -1-1z","key":0}),React.createElement("path",{"d":"m22 8.75h-2v-1.75a4 4 0 0 0 -8 0v1.75h-2v-1.75a6 6 0 0 1 12 0z","key":1}),React.createElement("path",{"d":"m24.9 30h-17.8a2 2 0 0 1 -2-2.1l.81-17.24a2 2 0 0 1 2-1.91h16.18a2 2 0 0 1 2 1.91l.81 17.24a2 2 0 0 1 -2 2.1z","key":2})]));
}

Cart.defaultProps = {"height":"512","viewBox":"0 0 32 32","width":"512"};

module.exports = Cart;

Cart.default = Cart;
